import { render, staticRenderFns } from "./NextPetTagCTA.vue?vue&type=template&id=653e617f&scoped=true&"
import script from "./NextPetTagCTA.vue?vue&type=script&lang=js&"
export * from "./NextPetTagCTA.vue?vue&type=script&lang=js&"
import style0 from "./NextPetTagCTA.vue?vue&type=style&index=0&id=653e617f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653e617f",
  null
  
)

export default component.exports